import { useMemo, useState } from "react";

import type { WebsitesDigitalAssetRecord } from "app/pages/sales-intelligence/modules/company-analysis/types/digital-assets";

import { WEBSITES_PAGE_SIZE } from "../constants";

const isDataEmpty = (data: readonly WebsitesDigitalAssetRecord[] | undefined) => {
    return (
        !data ||
        data.length === 0 ||
        (data.length === 1 && data[0].domain === "" && data[0].visits === 0 && data[0].visitsHistory.length === 0)
    );
};

export const useFilteredTableData = (
    data: readonly WebsitesDigitalAssetRecord[] | undefined,
    isLoading: boolean,
    isFetched: boolean,
) => {
    const [page, setPage] = useState(1);

    const isEmpty = isDataEmpty(data) && isFetched;

    const displayedData = useMemo(() => data?.filter(({ domain }) => domain) ?? [], [data]);
    const totalRow = useMemo(() => data?.find(({ domain }) => domain === ""), [data]);

    const paginationProps = useMemo(
        () => ({
            pageSize: WEBSITES_PAGE_SIZE,
            total: displayedData.length,
            current: page,
            onChange(_currentPage: number, _pageSize: number, nextPage: number) {
                setPage(nextPage);
            },
        }),
        [displayedData, page],
    );

    return {
        displayedData,
        totalRow,
        paginationProps,
        isLoading,
        isEmpty,
    };
};
